import { LOCATION_CHANGE } from 'redux-first-history'
import {
  CLOSE_PREVIEW_NEW_ASSIGNMENT,
  GET_ASSIGNMENTS_SUCCESS,
  OPEN_ASSIGNMENT_FORM_DIALOG,
  CLOSE_ASSIGNMENT_FORM_DIALOG,
  PREVIEW_NEW_ASSIGNMENT,
  ADD_NEW_ASSIGNMENT_SUCCESS,
  GET_ASSIGNMENT_BY_ID_SUCCESS,
  SET_ASSIGNMENT_FORM_READONLY,
  CANCEL_EDIT_ASSIGNMENT,
  UPDATE_ASSIGNMENT_SUCCESS,
  CLOSE_ASSIGNMENT_SNACKBAR,
  ADD_NEW_ASSIGNMENT_FAILED,
  SAVE_ASSIGNMENT_AS_DRAFT_SUCCESS,
  SAVE_ASSIGNMENT_AS_DRAFT_FAILED,
  DELETE_ASSIGNMENT_SUCCESS,
  COPY_ASSIGNMENT_SUCCESS,
  GET_AREA_OF_WORK_SUCCESS,
  GET_EMPLOYER_CONTRACT_LIST_SUCCESS,
  COPY_ASSIGNMENT,
  OFFER_AN_ASSIGNMENT_AGREEMENT,
  COMPLETE_OFFER_FORM,
  CANCEL_OFFER,
  OPEN_WARNING_CLOSE_COMPLETE_OFFER_FORM,
  CLOSE_WARNING_CLOSE_COMPLETE_OFFER_FORM,
  PREVIEW_ASSIGNMENT_SUCCESS,
  PREVIEW_ASSIGNMENT_FAILED,
  SIGN_SEND_CONTRACT_SUCCESS,
  ASSIGNMENT_PAGE_CHANGE,
  SIGN_SEND_CONTRACT_FAILED,
  GET_ASSIGNMENTS
} from '../../constants/employer'

const initialState = {
  assignmentRows: [],
  enableSaveButton: false, // Check to anable Save button
  assignmentFormValues: [],
  showPreview: false, // Show dialog preview
  isReadOnly: false,
  isEdit: false,
  assignmentEdit: [],
  showSnackbarAdd: false,
  showSnackbarUpdate: false,
  showFailedSnackbar: false,
  showDraftSnackbar: false,
  showFailedDraftSnackbar: false,
  showDeleteSnackbar: false,
  areaOfWork: [],
  employerContractList: [],
  openAssignmentForm: false,
  offerFromLightEntre: false, // Offer an assignment from Light Entrepreneurs page
  offerToEntrepreneur: [], // Selected person form Light Entrepreneurs page
  // showAskOfferContract: false, // After an assignment is created => show the dialog to ask if company want to offer an contract directly
  showContractOfferForm: false, // Show contract offer form
  latestAssignmentData: [],
  openWarningCloseCompleteForm: false,
  enableSendOrSignButton: false,
  previewFormValues: [],
  selected: 0,
  pageSize: 10,
  showSnackbarSendOffer: false,
  showFailSnackbarSendOffer: false
}

const assignmentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case OFFER_AN_ASSIGNMENT_AGREEMENT:
      return Object.assign(
        {},
        { ...state },
        {
          offerFromLightEntre: true,
          offerToEntrepreneur: action.selected
        }
      )
    case GET_ASSIGNMENTS:
      return Object.assign({}, { ...state }, {})
    case GET_ASSIGNMENTS_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          assignmentRows: action.data,
          latestAssignmentData: action.data[0]
        }
      )
    case GET_EMPLOYER_CONTRACT_LIST_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          employerContractList: action.data
        }
      )
    case COPY_ASSIGNMENT:
    case OPEN_ASSIGNMENT_FORM_DIALOG:
      return Object.assign(
        {},
        { ...state },
        {
          openAssignmentForm: true
        }
      )
    case CLOSE_ASSIGNMENT_FORM_DIALOG:
      return Object.assign(
        {},
        { ...state },
        {
          openAssignmentForm: false,
          isEdit: false,
          isReadOnly: false,
          offerFromLightEntre: false
        }
      )
    case PREVIEW_NEW_ASSIGNMENT:
      const result = action.values
      return Object.assign(
        {},
        { ...state },
        {
          assignmentFormValues: result,
          showPreview: true,
          enableSaveButton: false
        }
      )
    case PREVIEW_ASSIGNMENT_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          enableSendOrSignButton: true,
          previewFormValues: action.data
        }
      )
    case PREVIEW_ASSIGNMENT_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          enableSendOrSignButton: false
        }
      )
    case SIGN_SEND_CONTRACT_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          openAssignmentForm: false,
          offerFromLightEntre: false,
          offerToEntrepreneur: [],
          // showAskOfferContract: false,
          showContractOfferForm: false,
          latestAssignmentData: [],
          openWarningCloseCompleteForm: false,
          enableSendOrSignButton: false,
          previewFormValues: [],
          showSnackbarSendOffer: true,
          showFailSnackbarSendOffer: false
        }
      )
    case SIGN_SEND_CONTRACT_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showSnackbarSendOffer: false,
          showFailSnackbarSendOffer: true
        }
      )
    case CLOSE_PREVIEW_NEW_ASSIGNMENT:
      return Object.assign(
        {},
        { ...state },
        {
          showPreview: false,
          enableSaveButton: true
        }
      )
    case SAVE_ASSIGNMENT_AS_DRAFT_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          showDraftSnackbar: true,
          showFailedDraftSnackbar: false,
          openAssignmentForm: false
        }
      )
    case SAVE_ASSIGNMENT_AS_DRAFT_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showFailedDraftSnackbar: true,
          showDraftSnackbar: false
        }
      )
    case ADD_NEW_ASSIGNMENT_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          enableSaveButton: false,
          showSnackbarAdd: true,
          showSnackbarUpdate: false,
          showFailedSnackbar: false,
          isEdit: false,
          // showAskOfferContract: true,
          openAssignmentForm: false,
          offerFromLightEntre: false
        }
      )
    case COMPLETE_OFFER_FORM:
      return Object.assign(
        {},
        { ...state },
        {
          showContractOfferForm: true,
          // showAskOfferContract: false,
          openWarningCloseCompleteForm: false
        }
      )
    case ASSIGNMENT_PAGE_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          selected: action.selected.selected
        }
      )
    case CANCEL_OFFER:
      return Object.assign(
        {},
        { ...state },
        {
          showContractOfferForm: false,
          openWarningCloseCompleteForm: false
          // offerFromLightEntre: false,
          // enableSendOrSignButton: false
          // showAskOfferContract: false
        }
      )
    case OPEN_WARNING_CLOSE_COMPLETE_OFFER_FORM:
      return Object.assign(
        {},
        { ...state },
        {
          openWarningCloseCompleteForm: true
        }
      )
    case CLOSE_WARNING_CLOSE_COMPLETE_OFFER_FORM:
      return Object.assign(
        {},
        { ...state },
        {
          openWarningCloseCompleteForm: false
        }
      )

    case ADD_NEW_ASSIGNMENT_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showFailedSnackbar: true
        }
      )
    case UPDATE_ASSIGNMENT_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          enableSaveButton: false,
          showSnackbarAdd: false,
          showSnackbarUpdate: true,
          showFailedSnackbar: false,
          isEdit: false,
          assignmentEdit: [],
          openAssignmentForm: false
        }
      )
    case DELETE_ASSIGNMENT_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          showDeleteSnackbar: true
        }
      )
    case COPY_ASSIGNMENT_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          assignmentEdit: []
        }
      )

    case CLOSE_ASSIGNMENT_SNACKBAR:
      return Object.assign(
        {},
        { ...state },
        {
          showSnackbarAdd: false,
          showSnackbarUpdate: false,
          showFailedSnackbar: false,
          showDraftSnackbar: false,
          showFailedDraftSnackbar: false,
          showDeleteSnackbar: false,
          showSnackbarSendOffer: false,
          showFailSnackbarSendOffer: false
        }
      )
    case GET_ASSIGNMENT_BY_ID_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          isEdit: true,
          assignmentEdit: JSON.parse(action.result)
        }
      )

    case SET_ASSIGNMENT_FORM_READONLY:
      return Object.assign(
        {},
        { ...state },
        {
          isReadOnly: action.payload
        }
      )
    case CANCEL_EDIT_ASSIGNMENT:
      return Object.assign(
        {},
        { ...state },
        {
          isEdit: false,
          assignmentEdit: [],
          enableSaveButton: false,
          openAssignmentForm: false
        }
      )
    case GET_AREA_OF_WORK_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          areaOfWork: action.data
        }
      )
    case LOCATION_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          enableSaveButton: false,
          showPreview: false,
          isEdit: false,
          assignmentEdit: [],
          showSnackbarAdd: false,
          showSnackbarUpdate: false,
          showFailedSnackbar: false,
          showDeleteSnackbar: false,
          openAssignmentForm: false,
          openWarningCloseCompleteForm: false,
          showContractOfferForm: false,
          enableSendOrSignButton: false,
          selected: 0,
          showSnackbarSendOffer: false,
          showFailSnackbarSendOffer: false
        }
      )
    default:
      return state
  }
}

export default assignmentsReducer
